// extracted by mini-css-extract-plugin
module.exports = {"container":"UserMenu_container__2Z8h6","box":"UserMenu_box__1F9W6","name":"UserMenu_name__1PdDC","button":"UserMenu_button__174Hn"};